<script>
		import { user } from "../client.svelte.js";
		import { narrate, taleStates, tales_of, can_start, start_tale, open_tale, fellow_name } from "./_Narrate.svelte";

		let tales = $derived(tales_of(view.fellowship.ID))

		function start(e, tale) {
				e.stopPropagation()		// do not open the tale details
				start_tale(tale)
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<article>
	<h2 class="page-title">Liste der bisherigen Abenteuer</h2>
	{#if !view.fellowship}
		<p class="card-meta">Bitte wähle zuerst in der Gruppenübersicht eine Gruppe aus.</p>
	{:else if tales.length === 0}
		<p class="card-meta">Diese Gruppe hat noch kein Abenteuer gespielt.</p>
	{:else}
		<div class="talesList">
			<div class="talesRow header card-kicker">
				<span>Nr</span>
				<span>Name</span>
				<span>Meister</span>
				<span>Status</span>
				<span>Aktion</span>
			</div>
			{#each tales as tale (tale.ID)}
				{@const state = taleStates[tale.state] ?? taleStates[0]}
				<div class="talesRow" data-help="tale" role="button" tabindex="0" onclick={() => open_tale(tale.ID)}
				     onkeydown={(e) => e.key === 'Enter' && open_tale(tale.ID)}>
					<span class="num">{tale.NUM}</span>
					<div>
						<div class="taleName">{tale.name}</div>
						<div class="card-meta">{[tale.region, tale.campaigne].filter(Boolean).join(" · ")}</div>
					</div>
					<span>{fellow_name(tale.master)}</span>
					<span><span class="tag {state.tag}">{state.label}</span></span>
					<span>
						{#if can_start(tale)}
							<button class="btn-primary btn-primary-circle icon-play" data-help="start" onclick={(e) => start(e, tale)}>starten</button>
						{/if}
					</span>
				</div>
			{/each}
		</div>
	{/if}
</article>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.talesList
		max-width: 1100px

	.talesRow
		display: grid
		grid-template-columns: 5ch minmax(0, 3fr) minmax(0, 1fr) 16ch 16ch
		gap: 0 16px
		align-items: center
		min-height: 52px
		padding: 6px 10px
		border-bottom: 1px solid colors.$grey-20
		cursor: pointer

		&:hover:not(.header), &:focus-visible
			background: colors.$grey-15
			outline: none

		&.header
			min-height: 0
			padding-bottom: 8px
			border-bottom: 1px solid colors.$primary-100
			cursor: default

	.num
		color: colors.$grey-50

	.taleName
		font-weight: bold
</style>
